import React  from 'react';
import './Other.css';

const Other = function(props) {

  var data_pubs = [
    {
      img: "img/pubs/th.png",
      ptype: "PhD Dissertation (USP)",
      title: "Graph signal processing for visual analysis and data exploration",
      authors: "P. Valdivia",
      year: "May 2018",
      link: "phd_slides",
      keyfile: "files/phd_slides.key"
    },
    {
      img: "img/pubs/waviz_ui.png",
      ptype: "PhD Qualification (USP)",
      title: "Wavelet-based visualization of time-varying data on graphs",
      authors: "P. Valdivia",
      year: "June 2015",
      pdf: "files/quali_slides.pdf"
    },{
      img: "img/other/cluster.png",
      ptype: "Infovis course project (NYU)",
      title: "Hierarchical cluster summary ",
      authors: "J. P. Ono and P. Valdivia",
      year: "2015",
      description: "Visual analysis of clusters resulting from hierarchical clustering mechanisms.",
      demo: "cluster",
      git: "https://github.com/nyu-cs6313-fall2015/Group-12/"
    },{
      img: "img/other/fig1.png",
      ptype: "Master Dissertation (USP)",
      title: "Correção de Normais para Filtragem de Nuvens de Pontos",
      authors: "P. Valdivia",
      year: "November 2013",
      pdf: "iles/msc_slides.pdf"
    }
  ];

  var publications = data_pubs.map((pub, i) => {
    return(
      <span key={i}>
          <dl className="publication">
            <dt className="figure">
              {pub.img && <img alt={pub.title} src={pub.img} /> }
            </dt>
            <dd className="ref">
              <span className="ptype"> {pub.ptype} </span>&nbsp;&nbsp;
              <span className="year"> {pub.year}.</span>
              <span className="ptitle">  {pub.title} </span>
              <span className="authors"> {pub.authors} </span>
              <span className="description">  {pub.description} </span>
              {pub.pdf && <span className="document"> <a href={pub.pdf}> <img alt="pdf" src="img/pdf.png" className="icon" /> </a> </span>}
              {pub.keyfile && <span className="document"> <a href={pub.keyfile}> <img alt="keynote file" src="img/Keynote-icon.png" className="icon" />  </a> </span>}
              {pub.link && <span className="document"> <a href={pub.link}> <img alt="link" src="img/link.png" className="icon" /> </a></span>}
              {pub.demo && <span className="document"> <a href={pub.demo}> live demo </a> </span>}
              {pub.git && <span className="document"> <a href={pub.git}> <img alt="pdf" src="img/github.png" className="icon" /> </a> </span>}
            </dd>
          </dl>
          <div className="space"></div>
        </span>
    );
  });

  return (
    <div  id="other" className="other">

      <div className="space"></div>
      <h2>
        OTHER
      </h2>
      <div className="space"></div>

      {publications}

      <div className="space-lg"></div>

    </div>

  );
}

export default Other;



// WEBPACK FOOTER //
// ./src/Other.js